import { sortBy } from 'lodash';
import { IrelandEnsNotification } from '../../../../store/declarations/ireland/entry-summary-notification';
import {
    AesInvalidNotification,
    AesNotification,
    AesRejectedNotification,
} from '../../../../store/declarations/ireland/export-declaration';
import { IrelandNotification } from '../../../../store/declarations/ireland/ireland-notification';
import { CdsExportNotification } from '../../../../store/declarations/uk/cds-declaration';
import { GmrNotification } from '../../../../store/declarations/uk/gvms-declaration';
import { DeclarationsPayloads } from '../../utils/declaration-utils';
import {
    getIcs2NotificationErrors,
    isIcs2CustomsRequestNotification,
    isSupersededIcs2Notification,
} from './declaration-notifications/ics2/ics2NotificationUtils';

type Options = {
    /** Keep IE3Q02/IE3Q03: the caller asked for one specific message, not for what is outstanding. */
    includeCustomsRequests?: boolean;
};

const extractNotificationsData = (
    declarationPayload: DeclarationsPayloads | undefined | null,
    { includeCustomsRequests = false }: Options = {}
) => {
    if (!declarationPayload) return {};
    if (!declarationPayload?.notifications) return {};

    const notifications = declarationPayload.notifications.filter(
        (declarationNotification) =>
            !isSupersededIcs2Notification(declarationNotification) &&
            (includeCustomsRequests || !isIcs2CustomsRequestNotification(declarationNotification))
    );

    const lastNotificationIndex = notifications.length - 1;

    const sortedNotifications = notifications.some(
        (declarationNotification) =>
            'notificationDate' in declarationNotification ||
            'createdAt' in declarationNotification ||
            'issueDateTime' in declarationNotification
    )
        ? sortBy(notifications, ['notificationDate', 'createdAt', 'issueDateTime'])
        : notifications;

    const latestNotification = sortedNotifications?.[lastNotificationIndex];

    const declarationNotificationErrors =
        (latestNotification as IrelandNotification | undefined)?.submissionErrors ?? // Ireland Import
        (latestNotification as IrelandEnsNotification | undefined)?.rejectedNotification?.errors ?? // ENS
        (latestNotification as CdsExportNotification | undefined)?.validationMessages ?? // CDS Export
        (((latestNotification as AesNotification)?.notification as AesRejectedNotification)?.functionalError ||
            ((latestNotification as AesNotification)?.notification as AesInvalidNotification)?.xmlError) ?? // Ireland Export
        (latestNotification as GmrNotification)?.message?.ruleFailures ?? // GMR
        getIcs2NotificationErrors(latestNotification) ?? // ICS2 ENS (IE3N01 / IE3N99)
        (latestNotification?.notification?.XMLError || latestNotification?.notification?.FunctionalError); // Ireland NCTS;

    return { sortedNotifications, latestNotification, declarationNotificationErrors };
};

export default extractNotificationsData;
